import { playerName } from "../types";
import { BallotTally } from "./PresenterParts";
import type { GameView } from "../../../server/protocol";
export function accusationResultTitle(game: GameView) {
  const outcome = game.public.result?.outcome;
  const opponent = game.id === "alibi" ? "Spy" : "Impostor";
  return outcome === "caught"
    ? "Locals win."
    : outcome === "guessed-word" || outcome === "correct-guess"
      ? `${opponent} wins.`
      : outcome === "wrong-guess"
        ? "Locals win."
        : outcome === "wrong-accusation"
          ? `${opponent} wins: wrong accusation.`
          : outcome === "escaped-tie"
            ? `${opponent} wins: tied vote.`
            : "Result.";
}
/** Final public result as an announcement card: who it was, then the facts. */
export function AccusationOutcome({
  game: g,
  expanded = false,
  viewerId = null,
}: {
  game: GameView;
  /** Shared display: the vote recap is shown in full, never behind a disclosure. */
  expanded?: boolean;
  viewerId?: string | null;
}) {
  const p = g.public,
    r = p.result,
    n = (id: string) => playerName(p.players ?? [], id);
  const facts: [string, string][] = [];
  if (r?.localWord) facts.push(["The word was", r.localWord]);
  if (r?.impostorWord) facts.push(["The other word was", r.impostorWord]);
  if (r?.locationId)
    facts.push([
      "The location was",
      p.locations?.find((v: any) => v.id === r.locationId)?.name ?? "—",
    ]);
  if (r?.guessedWord)
    facts.push([
      "Final guess",
      `“${r.guessedWord}” · ${r.guessCorrect ? "correct" : "not the word"}`,
    ]);
  return (
    <>
      {r ? (
        <div className="play-announcement" data-tour="outcome">
          {r.impostorId || r.spyId ? (
            <p className="announce-lead">
              {r.impostorId
                ? `${n(r.impostorId)} was the impostor.`
                : `${n(r.spyId)} was the spy.`}
            </p>
          ) : null}
          {facts.length ? (
            <dl className="announce-facts">
              {facts.map(([k, v]) => (
                <div key={k}>
                  <dt>{k}</dt>
                  <dd>{v}</dd>
                </div>
              ))}
            </dl>
          ) : null}
        </div>
      ) : null}
      {p.revealedBallots?.length && expanded ? (
        <BallotTally
          players={p.players ?? []}
          ballots={p.revealedBallots}
          viewerId={viewerId}
          heading="Vote recap"
        />
      ) : p.revealedBallots?.length ? (
        <details className="play-finished-ballots">
          <summary>Vote recap</summary>
          <ul className="plain-list">
            {p.revealedBallots.map((v: any) => (
              <li
                key={v.playerId}
              >{`${n(v.playerId)} → ${v.targetId ? n(v.targetId) : "abstained"}`}</li>
            ))}
          </ul>
        </details>
      ) : null}
    </>
  );
}
